import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { shareContent } from '../../../actions/spaces/ShareContentAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource } from './IEntityActionHelpers';

export const ShareContentAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.ShareContent,
  translateName: Messages.share_content_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.newShareDialogEnabled && !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IContentInfo[]) => {
    return shareContent(targetItems[0]);
  }
};
